import { gql } from '@apollo/client';

export const CREATE_TMS_TASK_WAYPOINT_LOCATION_INFO = gql`
  mutation CreateTmsTaskWaypointLocationInfo($input: CreateTmsTaskWaypointLocationInfoInput!) {
    createTmsTaskWaypointLocationInfo(input: $input)
  }
`;

export interface CreateTmsTaskWaypointLocationInfoInput {
  taskId: number;
  taskWaypointId: number;
  nodeType: number;
  latitude?: number | null;
  longitude?: number | null;
  parsedAddress?: string | null;
}
